/** Shared admin session for the floating Manage-your-site panel. */

export const ADMIN_TOKEN_KEY = 'su-site-admin-token';
export const ADMIN_PANEL_OPEN_KEY = 'su-site-admin-open';
export const ADMIN_SESSION_EVENT = 'su-admin-session';

export function loadAdminToken(): string {
  try {
    return sessionStorage.getItem(ADMIN_TOKEN_KEY) ?? '';
  } catch {
    return '';
  }
}

export function saveAdminToken(token: string) {
  try {
    if (token) sessionStorage.setItem(ADMIN_TOKEN_KEY, token);
    else sessionStorage.removeItem(ADMIN_TOKEN_KEY);
  } catch {
    /* ignore */
  }
  notifyAdminSession();
}

export function isAdminPanelOpen(): boolean {
  try {
    return sessionStorage.getItem(ADMIN_PANEL_OPEN_KEY) === '1';
  } catch {
    return false;
  }
}

export function setAdminPanelOpen(open: boolean) {
  try {
    if (open) sessionStorage.setItem(ADMIN_PANEL_OPEN_KEY, '1');
    else sessionStorage.removeItem(ADMIN_PANEL_OPEN_KEY);
  } catch {
    /* ignore */
  }
  notifyAdminSession();
}

export function notifyAdminSession() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(ADMIN_SESSION_EVENT));
  }
}

export function subscribeAdminSession(cb: () => void): () => void {
  if (typeof window === 'undefined') return () => undefined;
  window.addEventListener(ADMIN_SESSION_EVENT, cb);
  window.addEventListener('storage', cb);
  return () => {
    window.removeEventListener(ADMIN_SESSION_EVENT, cb);
    window.removeEventListener('storage', cb);
  };
}
